"use client";

import type { FC } from "react";
import { splitFitnessHeadline } from "@/src/hooks/onboarding/splitFitnessHeadline";

export interface FitnessScoreHeadlineProps {
  headline: string;
  scoreBasis: string;
}

export const FitnessScoreHeadline: FC<FitnessScoreHeadlineProps> = ({
  headline,
  scoreBasis,
}) => {
  const { accentPart, restPart } = splitFitnessHeadline(headline);

  return (
    <div
      className="flex w-full flex-col items-center gap-3 text-center"
      data-testid="fitness-score-headline"
      data-figma-node="97267:68855"
    >
      <h1 className="headline_regular_m tracking-[-0.96px]">
        <span className="text-content_accent4_primary">{accentPart}</span>
        {restPart ? (
          <span className="text-content_primary">{restPart}</span>
        ) : null}
      </h1>
      <p className="body_m max-w-[320px] text-content_secondary">
        {scoreBasis}
      </p>
    </div>
  );
};
